import mail from './mail'
import folder from './folder'
import favorite from './favorite'

export default {
    mail,
    folder,
    favorite
}